<template>
    <div v-if="loading" class="tw-bg-white tw-rounded tw-p-2 tw-border tw-border-solid tw-border-gray-200 tw-min-h-[300px]">
        <div class="tw-flex tw-items-center tw-gap-2">
            <p class="tw-p-2 tw-font-bold tw-text-lg">{{ $t('fields.delivery_status') }}</p>
            <p class="tw-px-1 tw-bg-gray-900 tw-text-white tw-text-sm tw-rounded"><icon icon="eos-icons:three-dots-loading" class="tw-text-xl" /></p>
        </div>

        <div class="tw-flex tw-gap-x">
            <div class="tw-w-[50%] tw-p-5 tw-h-[200px] tw-flex tw-items-center tw-justify-center">
                <div class=" tw-h-[180px] tw-p-2 tw-bg-gray-100 tw-rounded-full tw-aspect-square tw-animate-pulse">
                </div>
            </div>
            <div class="tw-w-[50%] tw-p-2 tw-h-[200px] tw-flex tw-justify-center tw-flex-col tw-gap-5">
                <div class="tw-w-[60%] tw-p-2 tw-bg-gray-100 tw-rounded-full tw-animate-pulse"></div>
                <div class="tw-w-[60%] tw-p-2 tw-bg-gray-100 tw-rounded-full tw-animate-pulse"></div>
                <div class="tw-w-[60%] tw-p-2 tw-bg-gray-100 tw-rounded-full tw-animate-pulse"></div>
            </div>
        </div>
    </div>
    <div v-else class="tw-bg-white tw-p-2 tw-border tw-rounded tw-border-solid tw-border-gray-200 tw-min-h-[300px]">
        <div class="tw-flex tw-items-center tw-gap-2">
            <p class="tw-p-2 tw-font-bold tw-text-lg">{{ $t('fields.delivery_status') }}</p>
            <p class="tw-px-1 tw-bg-gray-900 tw-text-white tw-text-sm tw-rounded">{{ new Intl.NumberFormat().format(total)  }}</p>
        </div>
        <div class="tw-h-fullx tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
            <div class="tw-w-1/3x">
                <apexchart type="radialBar" height="250" class="" :options="options" :series="series"></apexchart>
            </div>
            <div class="tw-flex-1 tw-p-2 tw-grid xl:tw-grid-cols-2 tw-grid-cols-1 tw-gap-3">
                <router-link :to="{ name: 'pages.admin.orders', query: { delivery_status: c.value } }" v-for="c in data.deliveries" :key="c" class="tw-flex tw-items-center tw-gap-2">
                    <div :class="[c.color]" class="tw-p-0 tw-px-1 tw-rounded tw-text-[12px] tw-font-bold tw-text-center tw-w-[42px]">{{ c.percentage }}%</div>
                    <div class="tw-flex tw-items-center tw-gap-1">
                        <p :title="$t(c.name)" class="tw-text-sm tw-font-semibold tw-max-w-[100px] tw-truncate">{{ $t(c.name) }}</p>
                        <span class="tw-text-xs">({{ new Intl.NumberFormat().format(c.count) }})</span>
                    </div>
                </router-link> 
            </div>

        </div>
    </div>
</template>

<script setup>
import { followupManager } from '@/api/dashboard';
import { order_deliveries } from '@/config/status';
import { ref, computed, inject, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const loading = ref(true);
const total = ref(0);
const i18n = useI18n()
const filters = inject('filters')

// const data = ref([]);

const data = ref({
    deliveries: [
        // { name: 'Total', value: 450, percentage: '100%', color: '#000' },
        // { name: 'delivered', value: 225, percentage: '77%', color: '#10b981' },
        // { name: 'Double', value: 225, percentage: '77%', color: '#8b5cf6' },
        // { name: 'Canceled', value: 225, percentage: '77%', color: '#e11d48' },
        // { name: 'No Answer', value: 225, percentage: '77%', color: '#f59e0b' },
        // { name: 'Others', value: 225, percentage: '77%', color: '#64748b' },
    ]
})
const series = ref([77]);

const options = computed(() => ({
    chart: {
        type: 'radialBar',
        toolbar: {
            show: false
        }
    },
    plotOptions: {
        radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
                margin: 0,
                size: '70%',
                background: '#fff',
                image: undefined,
                imageOffsetX: 0,
                imageOffsetY: 0,
                position: 'front',
                dropShadow: {
                    enabled: true,
                    top: 3,
                    left: 0,
                    blur: 4,
                    opacity: 0.24
                }
            },
            track: {
                background: '#fff',
                strokeWidth: '67%',
                margin: 0,
                dropShadow: {
                    enabled: true,
                    top: -3,
                    left: 0,
                    blur: 4,
                    opacity: 0.35
                }
            },
            dataLabels: {
                show: true,
                name: {
                    offsetY: -10,
                    show: true,
                    color: '#888',
                    fontSize: '17px',
                    fontFamily: 'cairo',
                    fontWeight: 'medium',
                },
                value: {
                    formatter: function (val) {
                        return val + '%';
                    },
                    color: '#111',
                    fontFamily: 'cairo',
                    fontSize: '36px',
                    show: true
                }
            }
        }
    },
    fill: {
        type: 'gradient',
        colors: series.value[0] > 50 ? ['#10b981'] : ['#f43f5e'],
        gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: series.value[0] > 50 ? ['#22c55e', '#10b981'] : ['#f43f5e', '#e11d48'],
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
        }
    },
    stroke: {
        lineCap: 'round'
    },
    labels: [i18n.t('common.delivered')]
}));


const getData = async () => {
    loading.value = true;
    await followupManager.delivery(filters.value)
    .then(
        res => {
            handleData(res.data.data)
        },
        err => {
            console.log(err)
        }
    )
    loading.value = false
}

const handleData = dt => {
    total.value = dt.reduce((a, b) => a + b.count, 0); 

    const delivered = dt.find(o => o.delivery_status == 'delivered')?.count ?? 0;
    const settled = dt.find(o => o.delivery_status == 'settled')?.count ?? 0;
    const delivery_rate = delivered + settled;
    series.value = [ delivery_rate > 0 ? ((delivery_rate / total.value) * 100).toFixed(1) : 0];

    data.value.deliveries = dt.map(
        i => {
            const c = order_deliveries.find(o => o.value == i.delivery_status);

            return {...c, value: c.value, count: i.count, percentage: i.count > 0 ? ((i.count / total.value) * 100).toFixed(1) : 0 }
        }
    )
}
getData();
watch(() => filters.value, () => {
    getData()
}, { deep: true })

</script>

<style>
/* Add any custom styles here */
</style>